import "@babel/polyfill";
import "bootstrap";
import {
  closest,
  includes,
  remove
} from "./polyfills";
import {
  fullPageScroll,
  anchorTags,
  layoutUtils,
  imageManager,
  keyboardManager,
  superscript,
  pdfGenerator
} from "./utils";
import {
  header,
  heroCarousel,
  productGrid,
  carousel,
  readMore,
  videoTutorial,
  featuredArticleList,
  search,
  brandFilter,
  formFields,
  locationSelector,
  scrollToTop,
  formFieldsIsRequired,
  progressBar
} from "./components";

function init() {
  closest.init();
  includes.init();
  remove.init();
  fullPageScroll.init();
  anchorTags.init();
  header.init();
  heroCarousel.init();
  productGrid.init();
  carousel.init();
  readMore.init();
  videoTutorial.init();
  featuredArticleList.init();
  search.init();
  layoutUtils.init();
  brandFilter.init();
  formFields.init();
  imageManager.init();
  keyboardManager.init();
  locationSelector.init();
  scrollToTop.init();
  formFieldsIsRequired.init();
  superscript.init();
  pdfGenerator.init();
  progressBar.init();


  // Redirect all MSDS link clicks to ecolab.com (SITE-1204)
  document.addEventListener('click', e => {
    try {
      if(document.querySelector('.breadcrumb li:last-of-type').innerText.trim().toLowerCase() === 'safety data sheets') {
        if(e.target.classList.contains('listing-item-title-link') && e.target.href.toLowerCase().indexOf('msds') > -1) {
          e.preventDefault();
          window.open('https://www.ecolab.com/', '_blank').focus();
          return false;
        }
      }
    } catch(err) {}
  });
}

window.addEventListener("DOMContentLoaded", init);
